export type InPageSurveyUiType = 'NORMAL' | 'GRID';

const NORMAL = 'NORMAL';
const GRID = 'GRID';

export const inPageSurveyUiType: {
  NORMAL: InPageSurveyUiType;
  GRID: InPageSurveyUiType;
} = {
  NORMAL,
  GRID,
};
